import { memo, useEffect } from 'react';
import { buildHandleId } from '../../lib/utils';
import { HANDLES_TYPES, NODES_TYPES } from '../../types';
import { ConditionType } from '@src/components/generated/graphql';
import { INTERACTION_TYPES } from 'util/constants';
import { useUpdateNodeInternals } from '@xyflow/react';
import CustomNode from './CustomNode';
import HandlesWrapper from '../HandlesWrapper';
import styles from '../../timeline-node-manager.module.css';

type DestroyableNodeProps = {
  id: string;
  data: {
    params: {
      interactionType: INTERACTION_TYPES.CLICK;
      targetId: string;
      lifespan: number;
    };
    type: ConditionType.Interaction;
  };
  type: NODES_TYPES;
  selected: boolean;
};

const DestroyableNode = ({
  id,
  data,
  type,
  selected,
}: DestroyableNodeProps) => {
  const updateNodeInternals = useUpdateNodeInternals();

  useEffect(() => {
    updateNodeInternals(id);
  }, [data]);

  return (
    <CustomNode
      id={id}
      type={type}
      data={data}
      label={'Destroyable'}
      containerClassname={styles.conditionNode}
      selected={selected}
    >
      <HandlesWrapper
        sources={[
          {
            id: buildHandleId({
              type: 'input',
              handleType: HANDLES_TYPES.QUEST,
              nodeId: id,
            }),
            label: 'Quest',
          },
        ]}
        targets={[
          {
            id: buildHandleId({
              type: 'output',
              handleType: HANDLES_TYPES.DESTROYABLE,
              nodeId: id,
            }),
            label: 'On Complete',
          },
        ]}
      />
    </CustomNode>
  );
};

export default memo(DestroyableNode);
